import { Strategy as StrategyType } from './utils'
import Styles from './StrategiesSelection.module.scss'
import { Text } from 'blaze-ui/Text/Text'
import { pluralize } from 'utils'

export interface StrategyValuesMobileV2Props {
  strategy: StrategyType
}

export const StrategyValuesMobileV2 = ({ strategy }: StrategyValuesMobileV2Props) => {
  const seoContentsCount = strategy.seo_contents.find((content) => content.type === 'blog_post')?.count || 0
  const newsletterContentsCount = strategy.email_contents.find((content) => content.type === 'newsletter')?.count || 0
  const stillImageSocialCrosspostContentsCount =
    strategy.crosspost_contents.find((content) => content.content_type === 'still_image')?.count || 0
  const carouselSocialCrosspostContentsCount =
    strategy.crosspost_contents.find((content) => content.content_type === 'carousel')?.count || 0
  const videoSocialCrosspostContentsCount =
    strategy.crosspost_contents.find((content) => content.content_type === 'video')?.count || 0
  const videoCrosspostContentsCount =
    strategy.video_crosspost_contents.find((content) => content.type === 'post')?.count || 0

  return (
    <div className={Styles.strategyValues}>
      <span className={Styles.strategyValuesHeader}>
        <Text variant="label" color="var(--dark-40)">
          Content per week:
        </Text>
      </span>
      {stillImageSocialCrosspostContentsCount > 0 && (
        <div className={Styles.strategyValue}>
          <Text variant="label">
            <span className={Styles.strategyValueCount}>{stillImageSocialCrosspostContentsCount}</span>Still{' '}
            {pluralize('image', stillImageSocialCrosspostContentsCount)},
          </Text>
        </div>
      )}
      {carouselSocialCrosspostContentsCount > 0 && (
        <div className={Styles.strategyValue}>
          <Text variant="label">
            <span className={Styles.strategyValueCount}>{carouselSocialCrosspostContentsCount}</span>{' '}
            {pluralize('Carousel', carouselSocialCrosspostContentsCount)},
          </Text>
        </div>
      )}
      {videoSocialCrosspostContentsCount > 0 && (
        <div className={Styles.strategyValue}>
          <Text variant="label">
            <span className={Styles.strategyValueCount}>{videoSocialCrosspostContentsCount}</span>Video Feed{' '}
            {pluralize('Post', videoSocialCrosspostContentsCount)},
          </Text>
        </div>
      )}
      {videoCrosspostContentsCount > 0 && (
        <div className={Styles.strategyValue}>
          <Text variant="label">
            <span className={Styles.strategyValueCount}>{videoCrosspostContentsCount}</span>
            {pluralize('Video', videoCrosspostContentsCount)},
          </Text>
        </div>
      )}
      {newsletterContentsCount > 0 && (
        <div className={Styles.strategyValue}>
          <Text variant="label">
            <span className={Styles.strategyValueCount}>{newsletterContentsCount}</span>
            {pluralize('Email', newsletterContentsCount)},
          </Text>
        </div>
      )}
      {seoContentsCount > 0 && (
        <div className={Styles.strategyValue}>
          <Text variant="label">
            <span className={Styles.strategyValueCount}>{seoContentsCount}</span>
            {pluralize('Blog', seoContentsCount)}
          </Text>
        </div>
      )}
    </div>
  )
}
